import { metaAccount } from '@/router/meta-config'
const permissionKey = 'DICTIONARY'

export default [
  {
    path: '/dictionaries',
    name: 'page-dictionaries',
    component: () => import('@/pages/dictionaries'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/dictionary/new',
    name: 'page-dictionary-new',
    component: () => import('@/pages/dictionary'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/dictionary/:id',
    name: 'page-dictionary',
    component: () => import('@/pages/dictionary'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
